import React from 'react'

import { useServiceOrder } from '../../_load/ServiceOrderLoader'
import { useChildrenServiceOrders } from '../../_load/ChildrenServiceOrdersLoader'
import { findReplyByQuestionId } from '../../_helpers/pdfHelpers'
import View from '../../../../../components/pdf/View'
import Text from '../../../../../components/pdf/Text'
import Image from '../../../../../components/pdf/Image'
import Header from '../../_shared/Header'
import { Table, TableCol, TableRow } from '../../../../../components/pdf/Table'
import Grid, { Col } from '../../../../../components/pdf/Grid'
import Separator from '../../../../../components/pdf/Separator'

const ResumoEstrategico = ({ headerValues }) => {
  const serviceOrder = useServiceOrder()
  const childrenServiceOrders = useChildrenServiceOrders()

  const allServiceOrders = [serviceOrder, ...childrenServiceOrders]

  const resumoEstrategicoServiceOrder = allServiceOrders.find(so => so.checklist.id === 4)
  const resumoEstrategicoReplies = resumoEstrategicoServiceOrder.replies

  const ambienteExternoCassificacao = findReplyByQuestionId(resumoEstrategicoReplies, 3462)?.value
  const ambienteExternoPFV = findReplyByQuestionId(resumoEstrategicoReplies, 250)?.value
  const ambienteExternoOMCP = findReplyByQuestionId(resumoEstrategicoReplies, 251)?.value
  const ambienteExternoOMLP = findReplyByQuestionId(resumoEstrategicoReplies, 252)?.value

  const ambienteInternoAPCassificacao = findReplyByQuestionId(resumoEstrategicoReplies, 3463)?.value
  const ambienteInternoAPPFV = findReplyByQuestionId(resumoEstrategicoReplies, 253)?.value
  const ambienteInternoAPOMCP = findReplyByQuestionId(resumoEstrategicoReplies, 254)?.value
  const ambienteInternoAPOMLP = findReplyByQuestionId(resumoEstrategicoReplies, 255)?.value

  const ambienteInternoCAPCassificacao = findReplyByQuestionId(resumoEstrategicoReplies, 3464)?.value
  const ambienteInternoCAPPFV = findReplyByQuestionId(resumoEstrategicoReplies, 256)?.value
  const ambienteInternoCAPOMCP = findReplyByQuestionId(resumoEstrategicoReplies, 257)?.value
  const ambienteInternoCAPOMLP = findReplyByQuestionId(resumoEstrategicoReplies, 258)?.value

  return (
    <View pageBreakAfter>
      <Header headerValues={headerValues} category="RESUMO EXECUTIVO POR UNIDADE" />

      <Table width="100%" useFontBaseColor>
        <TableRow useFontBaseColor bgColor="#333">
          <TableCol useFontBaseColor>
            <Text bold size={14} align="center" color="#fff">
              AMBIENTE EXTERNO
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor>
            <Text bold size={10} align="center">
              CLASSIFICAÇÃO
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor>
            <Grid justify="center">
              <Col>
                {ambienteExternoCassificacao.map(item => {
                  return <Image key={item.id} src={item.src} />
                })}
              </Col>
            </Grid>
          </TableCol>
        </TableRow>
        {ambienteExternoPFV && (
          <>
            <TableRow useFontBaseColor>
              <TableCol useFontBaseColor>
                <Text bold size={10} align="center">
                  SWOT
                </Text>
                <Text bold size={10} align="center">
                  PONTOS FRACOS/VULNERABILIDADES
                </Text>
              </TableCol>
            </TableRow>
            <TableRow useFontBaseColor>
              <TableCol useFontBaseColor>
                <Text size={12} align="justify">
                  {ambienteExternoPFV}
                </Text>
              </TableCol>
            </TableRow>
          </>
        )}
        {ambienteExternoOMCP && (
          <>
            <TableRow useFontBaseColor>
              <TableCol useFontBaseColor>
                <Text bold size={9} align="center">
                  SWOT
                </Text>
                <Text bold size={9} align="center">
                  OPORTUNIDADES DE MELHORIA NÍVEL GERENCIAL - CURTO PRAZO
                </Text>
              </TableCol>
            </TableRow>
            <TableRow useFontBaseColor>
              <TableCol useFontBaseColor>
                <Text size={12} align="justify">
                  {ambienteExternoOMCP}
                </Text>
              </TableCol>
            </TableRow>
          </>
        )}
        {ambienteExternoOMLP && (
          <>
            <TableRow useFontBaseColor>
              <TableCol useFontBaseColor>
                <Text bold size={9} align="center">
                  SWOT
                </Text>
                <Text bold size={9} align="center">
                  OPORTUNIDADES DE MELHORIA NÍVEL ESTRATÉGICO - MÉDIO PRAZO
                </Text>
              </TableCol>
            </TableRow>
            <TableRow useFontBaseColor>
              <TableCol useFontBaseColor>
                <Text size={12} align="justify">
                  {ambienteExternoOMLP}
                </Text>
              </TableCol>
            </TableRow>
          </>
        )}
      </Table>

      <Separator weight={10} />

      <Table width="100%" useFontBaseColor>
        <TableRow useFontBaseColor bgColor="#333">
          <TableCol useFontBaseColor>
            <Text bold size={14} align="center" color="#fff">
              AMBIENTE INTERNO - APENAS ÁREA PRIVATIVA
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor>
            <Text bold size={10} align="center">
              CLASSIFICAÇÃO
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor>
            <Grid justify="center">
              <Col>
                {ambienteInternoAPCassificacao.map(item => {
                  return <Image key={item.id} src={item.src} />
                })}
              </Col>
            </Grid>
          </TableCol>
        </TableRow>
        {ambienteInternoAPPFV && (
          <>
            <TableRow useFontBaseColor>
              <TableCol useFontBaseColor>
                <Text bold size={10} align="center">
                  SWOT
                </Text>
                <Text bold size={10} align="center">
                  PONTOS FRACOS/VULNERABILIDADES
                </Text>
              </TableCol>
            </TableRow>
            <TableRow useFontBaseColor>
              <TableCol useFontBaseColor>
                <Text size={12} align="justify">
                  {ambienteInternoAPPFV}
                </Text>
              </TableCol>
            </TableRow>
          </>
        )}
        {ambienteInternoAPOMCP && (
          <>
            <TableRow useFontBaseColor>
              <TableCol useFontBaseColor>
                <Text bold size={9} align="center">
                  SWOT
                </Text>
                <Text bold size={9} align="center">
                  OPORTUNIDADES DE MELHORIA NÍVEL GERENCIAL - CURTO PRAZO
                </Text>
              </TableCol>
            </TableRow>
            <TableRow useFontBaseColor>
              <TableCol useFontBaseColor>
                <Text size={12} align="justify">
                  {ambienteInternoAPOMCP}
                </Text>
              </TableCol>
            </TableRow>
          </>
        )}

        {ambienteInternoAPOMLP && (
          <>
            <TableRow useFontBaseColor>
              <TableCol useFontBaseColor>
                <Text bold size={9} align="center">
                  SWOT
                </Text>
                <Text bold size={9} align="center">
                  OPORTUNIDADES DE MELHORIA NÍVEL ESTRATÉGICO - MÉDIO PRAZO
                </Text>
              </TableCol>
            </TableRow>
            <TableRow useFontBaseColor>
              <TableCol useFontBaseColor>
                <Text size={12} align="justify">
                  {ambienteInternoAPOMLP}
                </Text>
              </TableCol>
            </TableRow>
          </>
        )}
      </Table>

      <Separator weight={10} />

      <Table width="100%" useFontBaseColor>
        <TableRow useFontBaseColor bgColor="#333">
          <TableCol useFontBaseColor>
            <Text bold size={14} align="center" color="#fff">
              AMBIENTE INTERNO - CONDOMÍNIO + ÁREA PRIVATIVA
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor>
            <Text bold size={10} align="center">
              CLASSIFICAÇÃO
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor>
            <Grid justify="center">
              <Col>
                {ambienteInternoCAPCassificacao.map(item => {
                  return <Image key={item.id} src={item.src} />
                })}
              </Col>
            </Grid>
          </TableCol>
        </TableRow>
        {ambienteInternoCAPPFV && (
          <>
            <TableRow useFontBaseColor>
              <TableCol useFontBaseColor>
                <Text bold size={10} align="center">
                  SWOT
                </Text>
                <Text bold size={10} align="center">
                  PONTOS FRACOS/VULNERABILIDADES
                </Text>
              </TableCol>
            </TableRow>
            <TableRow useFontBaseColor>
              <TableCol useFontBaseColor>
                <Text size={12} align="justify">
                  {ambienteInternoCAPPFV}
                </Text>
              </TableCol>
            </TableRow>
          </>
        )}
        {ambienteInternoCAPOMCP && (
          <>
            <TableRow useFontBaseColor>
              <TableCol useFontBaseColor>
                <Text bold size={9} align="center">
                  SWOT
                </Text>
                <Text bold size={9} align="center">
                  OPORTUNIDADES DE MELHORIA NÍVEL GERENCIAL - CURTO PRAZO
                </Text>
              </TableCol>
            </TableRow>
            <TableRow useFontBaseColor>
              <TableCol useFontBaseColor>
                <Text size={12} align="justify">
                  {ambienteInternoCAPOMCP}
                </Text>
              </TableCol>
            </TableRow>
          </>
        )}
        {ambienteInternoCAPOMLP && (
          <>
            <TableRow useFontBaseColor>
              <TableCol useFontBaseColor>
                <Text bold size={9} align="center">
                  SWOT
                </Text>
                <Text bold size={9} align="center">
                  OPORTUNIDADES DE MELHORIA NÍVEL ESTRATÉGICO - MÉDIO PRAZO
                </Text>
              </TableCol>
            </TableRow>
            <TableRow useFontBaseColor>
              <TableCol useFontBaseColor>
                <Text size={12} align="justify">
                  {ambienteInternoCAPOMLP}
                </Text>
              </TableCol>
            </TableRow>
          </>
        )}
      </Table>
    </View>
  )
}

export default ResumoEstrategico
